import { PayloadAction } from '@reduxjs/toolkit'
import { reducerCreatorProducer } from 'store/common'
import { IUserState } from 'store/types/user'
import {
  IActiveHighestSubscriptionData,
  IUser,
  IUnlimitedAiVideoModel
} from 'types/user'
import { IUserStats } from 'types/userStats'

const reducers = reducerCreatorProducer<IUserState>()({
  setIsLoading: (state, action: PayloadAction<boolean>) => {
    state.isLoading = action.payload
  },
  setUser: (state, action: PayloadAction<IUser>) => {
    state.data = action.payload
  },
  setActiveHighestSubscription: (
    state,
    action: PayloadAction<IActiveHighestSubscriptionData>
  ) => {
    state.activeHighestSubscription.data = action.payload
  },
  setActiveHighestSubscriptionIsLoading: (
    state,
    action: PayloadAction<boolean>
  ) => {
    state.activeHighestSubscription.isLoading = action.payload
  },
  setUserStats: (state, action: PayloadAction<IUserStats>) => {
    state.userStats = action.payload
  },
  setUserCurrentTariffId: (state, action: PayloadAction<number>) => {
    state.userCurrentTariffId = action.payload
  },
  setUnlimitedAiImageModelIds: (state, action: PayloadAction<number[]>) => {
    state.unlimitedAiImageModelIds = action.payload
  },
  setUnlimitedAiVideoModels: (
    state,
    action: PayloadAction<IUnlimitedAiVideoModel[]>
  ) => {
    state.unlimitedAiVideoModels = action.payload
  }
})

export default reducers
